var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_OcrTemplateConfig"),
                  name: "ocrTemplateConfig"
                }
              },
              [
                _c("ocr-template-config", {
                  ref: "ocrTemplateConfig",
                  attrs: {
                    "tab-title": _vm.$t("CargoMsg.Cargo_OcrTemplateConfig")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t(
                    "CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration"
                  ),
                  name: "enterpriseInterfaceConfig"
                }
              },
              [
                _c("enterprise-interface-config", {
                  ref: "enterpriseInterfaceConfig",
                  attrs: {
                    "tab-title": _vm.$t(
                      "CargoMsg.Cargo_PlatformEnterpriseInterfaceConfiguration"
                    )
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }